import styled from 'styled-components'
import { page } from 'Global/theme'

const Page = styled.div`
    max-width: ${page.width};
    margin: 0 auto;
`

export default Page
